// Store ID
const account = 'compremais'
const production = 'somoscompremais'

// SalesChannels
const salesChannels = {
  default: 1,
  club: 2,
}

// Chat URL
const chatUrl =
  'https://chat.directtalk.com.br/static/?tenantId=ce7bcd84-2c17-4f58-a071-d9aa9cdc9b6c&templateId=2762d79c-145f-493c-a94f-d13b48ea18a8&departmentId=53db73b9-dc83-42c2-ab35-93b3cb57490d'

const salesForceActivated = true

// GTM-IDs
const gtmIdTest = 'GTM-MVWKZ3W'
const gtmIdProduction = 'GTM-NMKP2QQ'

module.exports = {
  account,
  production,

  // Ecommerce Platform
  platform: 'vtex',

  experimental: {
    nodeVersion: 14,
  },

  // Platform specific configs for API
  api: {
    storeId: account,
    environment: 'vtexcommercestable',
    hideUnavailableItems: true,
  },

  // Default channel
  session: {
    currency: {
      code: 'BRL',
      symbol: 'R$',
    },
    locale: 'pt-br',
    channel: `{"salesChannel":"${salesChannels.default}","regionId":""}`,
    country: 'BRA',
    postalCode: null,
    person: null,
  },

  /*
    https://www.somoscompremais.com.br
    https://secure.somoscompremais.com.br
  */
  // Production URLs
  storeUrl: `https://www.somoscompremais.com.br`,
  secureSubdomain: `https://secure.somoscompremais.com.br`,
  checkoutUrl: `https://secure.somoscompremais.com.br/api/io/cart`,
  loginUrl: `https://secure.somoscompremais.com.br/api/io/login`,
  accountUrl: `https://secure.somoscompremais.com.br/api/io/account`,
  chatUrl,
  salesForceActivated,

  // Jitterbit flows urls
  jitterbitUrls: {
    createUser:
      'https://smrholding.wevo.io/iomanager/api/flows/execute/route/prd/user/v1/create',
  },

  // Lighthouse CI
  lighthouse: {
    server: process.env.BASE_SITE_URL || 'http://localhost:9000',
    pages: {
      home: '/',
      pdp: '/apresuntado-fatiado-lanche-frimesa-bandeja-200g-2480/p',
      collection: '/alimentos/frios-e-embutidos/frios-e-fatiados/presuntos',
    },
  },

  // SalesChannels
  salesChannels,

  // E2E CI
  cypress: {
    pages: {
      home: '/',
      pdp: '/refrigerante-sem-acucar-coca-cola-pet-2l-357/p',
      collection: '/bebidas/bebidas/refrigerantes/cola',
      collection_filtered:
        '/bebidas/bebidas/refrigerantes/cola/?brand=coca-cola&category-1=bebidas&category-2=bebidas&category-3=refrigerantes&category-4=cola&facets=brand%2Ccategory-1%2Ccategory-2%2Ccategory-3%2Ccategory-4&sort=score_desc&page=0',
      search: '/s/?q=coca',
    },
  },

  hotjarId: '3312608',
  crazyEgg: true,

  // Meta Tags
  metaTags: {
    'google-site-verification': '31Io5qQ5gwQlNInC6MmQ3G1HtTfB2ajOyCOZiKWn9UE',
  },

  analytics: {
    // https://developers.google.com/tag-platform/tag-manager/web#standard_web_page_installation,
    gtmContainerId:
      process.env.FASTSTORE_ENV === 'production' ? gtmIdProduction : gtmIdTest,
  },
}
